import { render, staticRenderFns } from "./TextAreaField.vue?vue&type=template&id=f4ea9d82&scoped=true"
import script from "./TextAreaField.vue?vue&type=script&lang=js"
export * from "./TextAreaField.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4ea9d82",
  null
  
)

export default component.exports